module.exports = __webpack_public_path__ + "files/ec41ed1a5572e8e36696633b717fd632.png";